import { render, staticRenderFns } from "./tf.vue?vue&type=template&id=60ed4f76"
import script from "./tf.vue?vue&type=script&lang=js"
export * from "./tf.vue?vue&type=script&lang=js"
import style0 from "./tf.vue?vue&type=style&index=0&id=60ed4f76&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TfHeaderEplusAll: require('/usr/src/app/components/tf/header/eplus/all.vue').default,TfFooterEplusAll: require('/usr/src/app/components/tf/footer/eplus/all.vue').default,HomeHeader: require('/usr/src/app/components/Home/Header.vue').default,TfFooterAll: require('/usr/src/app/components/tf/footer/all.vue').default})
